import { CreateDosageBody, Dosage, UpdateDosageBody } from '@core/models/dosage.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class DosageService {
    private readonly createDosageURL = `/dosage/create_dosage`;
    private readonly updateDosageURL = `/dosage/update_dosage`;
    private readonly getDosagesURL = `/dosage/get_dosages`;
    private readonly deleteDosageURL = `/dosage/delete_dosage`;
    private readonly getDosageByIdURL = `/dosage/get_dosage`;

    // ---------------------------------------------------------------

    createDosage(body: CreateDosageBody) {
        return fetchWithRetry(API.post(this.createDosageURL, body));
    }

    updateDosage(body: UpdateDosageBody) {
        return fetchWithRetry(API.put(this.updateDosageURL, body));
    }

    getDosages() {
        return fetchWithRetry(API.get<Dosage[]>(this.getDosagesURL));
    }

    deleteDosage(id: number) {
        return fetchWithRetry(API.delete(`${this.deleteDosageURL}/${id}`));
    }

    getDosageById(id: number) {
        return fetchWithRetry(API.get<Dosage>(`${this.getDosageByIdURL}/${id}`));
    }
}

export default new DosageService();
